// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';
import { NEWS_SERVICE_CONSTS } from '@app/config/constants';

export interface INews {
  title: string;
  description: string;
  link: string;
  imagePath: string;
  dmImagePath: string;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService extends ApiService {
  private API_URL = environment.DEPS.NEWS_API.URL;
  consts = NEWS_SERVICE_CONSTS;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  allNews$ = this.get<INews[]>(`${this.API_URL}/news`).pipe(
    map((news) => news.slice(0, this.consts.MAX_CONTENT_LENGTH))
  );
}
